import { SvgProps } from '../SvgRendererTypes';

export const OrderHistoryIcon = ({ fillColor, ...props }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Order History Icon</title>
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 18C16.895 18 16 18.895 16 20C16 21.105 16.895 22 18 22C19.105 22 20 21.105 20 20C20 18.895 19.105 18 18 18ZM18 21C17.448 21 17 20.552 17 20C17 19.448 17.448 19 18 19C18.552 19 19 19.448 19 20C19 20.552 18.552 21 18 21ZM8 18C6.895 18 6 18.895 6 20C6 21.105 6.895 22 8 22C9.105 22 10 21.105 10 20C10 18.895 9.105 18 8 18ZM8 21C7.448 21 7 20.552 7 20C7 19.448 7.448 19 8 19C8.552 19 9 19.448 9 20C9 20.552 8.552 21 8 21ZM16 4C18.761 4 21 6.239 21 9C21 11.761 18.761 14 16 14C13.239 14 11 11.761 11 9C11 6.239 13.239 4 16 4ZM16 3C12.686 3 10 5.686 10 9C10 12.314 12.686 15 16 15C19.314 15 22 12.314 22 9C22 5.686 19.314 3 16 3ZM19.5 15C19.224 15 19 15.224 19 15.5V16H6.89L6.1 8H8.5C8.776 8 9 7.776 9 7.5C9 7.224 8.776 7 8.5 7H6L5.7 4H2.5C2.224 4 2 4.224 2 4.5C2 4.776 2.224 5 2.5 5H4.79L6 17H20V15.5C20 15.224 19.776 15 19.5 15ZM19.5 9.5H15.5V5.5C15.5 5.224 15.724 5 16 5C16.276 5 16.5 5.224 16.5 5.5V8.5H19.5C19.776 8.5 20 8.724 20 9C20 9.276 19.776 9.5 19.5 9.5Z"
      />
    </svg>
  );
};
